export const organization = {
  id: 'https://www.venturawebdesign.com/#organization',
  name: 'Ventura Web Design & Marketing',
  url: 'https://www.venturawebdesign.com',
  image: 'https://www.venturawebdesign.com/brand/meta/ventura-og.png',
  logo: 'https://www.venturawebdesign.com/brand/logos/ventura-logo.png',
  description:
    'Ventura Web Design & Marketing is a web design company and digital marketing agency that designs, builds, and markets professional ecommerce websites.',
  email: 'support@venturawebdesign.com',
  telephone: '+1-813-556-7990',
  foundingDate: '1997',
  founder: {
    name: 'Kevin Richards',
    url: 'https://www.venturawebdesign.com/about/kevin',
  },
  address: {
    streetAddress: '1810 W Kennedy Blvd Ste 323',
    addressLocality: 'Tampa',
    addressRegion: 'FL',
    postalCode: '33606',
    addressCountry: 'US',
  },
  sameAs: [
    'https://www.linkedin.com/company/ventura-web-design/',
    'https://www.facebook.com/venturawebdesign',
    'https://x.com/venturaweblv',
    'https://www.instagram.com/venturawebdesign/',
    'https://www.tiktok.com/@venturawebdesign',
    'https://www.youtube.com/user/venturawebdesign',
  ],
}
